import React from 'react'
import './menu.scss'

import { Link } from "react-router-dom"

import dashboardIcon from '../../../assets/svg/dashboardIcon.svg'
import resurantIcon from '../../../assets/svg/resturantIcon.svg'
import categoryIcon from '../../../assets/svg/categoryIcon.svg'
import foodIcon from '../../../assets/svg/foodIcon.svg'
import serverIcon from '../../../assets/svg/serverIcon.svg'
import supportIcon from '../../../assets/svg/supportIcon.svg'
import jobIcon from '../../../assets/svg/JobIcon.svg'
import reserveIcon from '../../../assets/svg/reservationIcon.svg'
import sliderIcon from '../../../assets/svg/sliderIcon.svg'
import fileIcon from '../../../assets/svg/fileIcon.svg'
import picIcon from '../../../assets/svg/Pic.svg'
import exitIcon from '../../../assets/svg/exitIcon.svg'

export default function index({ page, badgeCountDashboard, badgeCountOrder }) {
  return (
    <aside id='aside'>
      <Link to='/dashboard' className='column'>
        <div className={page === 'dashboard' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='' />
          <span>
            داشبورد اصلی
          </span>
        </div>
      </Link>
      <div className='title'>
        منوی داخلی
        <hr style={{ width: '65%' }} />
      </div>
      {/* item */}
      <Link to='/internalMenu' className='column'>
        <div className={page === 'dashboardIn' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='' />
          <span>
            منوی داخلی
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        رستوران شما
        <hr style={{ width: '65%' }} />
      </div>
      {/* item */}
      <Link to='/im/resturants' className='column'>
        <div className={page === 'resturant' ? 'row active' : 'row'}>
          <img src={resurantIcon} alt='' />
          <span>
            رستوران یا کافی‌شاپ
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/im/categories' className='column'>
        <div className={page === 'category' ? 'row active' : 'row'}>
          <img src={categoryIcon} alt='' />
          <span>
            دسته بندی
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/im/foods' className='column'>
        <div className={page === 'food' ? 'row active' : 'row'}>
          <img src={foodIcon} alt='' />
          <span>
            غذاها یا نوشیدنی‌ها
          </span>
        </div>
      </Link>
      {/* item */}
      <div className='title'>
        مدیریت 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/im/servers' className='column'>
        <div className={page === 'server' ? 'row active' : 'row'}>
          <img src={serverIcon} alt='' />
          <span>
            گارسون و میزها
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/im/faq' className='column'>
        <div className={page === 'faq' ? 'row active' : 'row'}>
          <img src={supportIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            سوالات متداول
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/im/jobs' className='column'>
        <div className={page === 'job' ? 'row active' : 'row'}>
          <img src={jobIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            درخواست شغل
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/im/reservation' className='column'>
        <div className={page === 'reservation' ? 'row active' : 'row'}>
          <img src={reserveIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            رزرو میز
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        اسلایدر 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/im/files' className='column'>
        <div className={page === 'files' ? 'row active' : 'row'}>
          <img src={fileIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            فایل
          </span>
        </div>
      </Link>
      <Link to='/im/sliders' className='column'>
        <div className={page === 'slider' ? 'row active' : 'row'}>
          <img src={sliderIcon} alt='' />
          <span>
            اسلایدر
          </span>
        </div>
      </Link>
      <Link to='/im/banners' className='column'>
        <div className={page === 'banner' ? 'row active' : 'row'}>
          <img src={picIcon} alt='' width={'22px'}/>
          <span>
            بنر
          </span>
        </div>
      </Link>
      <Link href='##'>
        <div className='support'>
          <span>
            +
          </span>
          <span>
            تماس با پشتیبانی
          </span>
          <span>
            5719 3559 - 041   
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/' className='column'>
        <div className={page === 'exit' ? 'row active' : 'row'}>
          <img src={exitIcon} alt='' />
          <span>
            خروج
          </span>
        </div>
      </Link>
    </aside>
  )
}
